import React from 'react'
import Icon from '@/components/Icon'
import { Popover } from '@/components/popover'

const HiddenButtons = props => {
  return (
    <div className='hidden-buttons'>
      <Popover content={props.children} trigger='hover' mouseEnterDelay={0.1} mouseLeaveDelay={0.1}>
        <button className='hidden-buttons__trigger'><Icon name='dots-horizontal-rounded' /></button>
      </Popover>
    </div>
  )
}

export default HiddenButtons



// WEBPACK FOOTER //
// ./src/components/hiddenButtons.js